export default __webpack_public_path__ + "static/media/digital-ready-infrastructure.62749017.svg";